// https://cnyesrd.atlassian.net/wiki/spaces/PS/pages/748683385
// https://cnyesrd.atlassian.net/wiki/spaces/PS/pages/2007072769

export const NEWS_CATEGORIES = {
  TWSTOCK: [826, 827, 828, 829, 862, 867, 906, 907, 908, 910, 911],
  CRYPTO: [873, 875, 876, 895, 909],
  INTERNATIONAL: [830, 831, 832, 833, 912],
  FOREX: [838, 885, 893, 915],
  REVENUE: [916]
};
